async function getAbout() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/about?populate=*`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getAbout;
